import React, { useState, useRef, useEffect } from 'react';
import '../styles/SplashScreen.css';

const SplashScreen = ({ onFinish }) => {

  const [started, setStarted] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  // Auto start video muted on load
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true;
      videoRef.current.play().catch(e => console.log(e));
    }
  }, []);

  const handleStart = async () => {
    setStarted(true);

    // Unmute video
    if (videoRef.current) {
      videoRef.current.muted = false;
    }

    // Play music
    if (audioRef.current) {
      audioRef.current.volume = 0.3;
      try {
        await audioRef.current.play();
      } catch (e) {
        console.log('Audio failed:', e);
      }
    }
  };

  const handleVideoEnd = () => {
    setFadeOut(true);
    if (audioRef.current) {
      audioRef.current.pause();
    }
    setTimeout(() => {
      onFinish();
    }, 800);
  };

  const handleVideoError = () => {
    setTimeout(() => {
      handleVideoEnd();
    }, 2100);
  };

  const handleSkip = () => {
    handleVideoEnd();
  };

  return (
    <div className={`splash-wrapper ${fadeOut ? 'splash-fadeout' : ''}`}>

      {/* BACKGROUND MUSIC */}
      <audio ref={audioRef}>
        <source src="/splash-music.mp3" type="audio/mp3" />
      </audio>

      {/* VIDEO — autoPlay muted */}
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        onEnded={handleVideoEnd}
        onError={handleVideoError}
        className="splash-video"
      >
        <source src="/splash-intro1.mp4" type="video/mp4" />
      </video>

      {/* DARK OVERLAY */}
      <div className="splash-overlay"></div>

      {/* TAP TO START SCREEN */}
      {!started && (
        <div className="splash-tap-screen" onClick={handleStart}>
          <p className="splash-tap-text">Tap to Enter</p>
        </div>
      )}

      {/* TEXT CONTENT */}
      {started && (
        <div className="splash-content">
        <h4 className="splash-title">
         ५८ वर्षांचा अखंड विश्वास .
        </h4>
          <h2 className="splash-title">
            दि सह्याद्री सहकारी बँक लिमिटेड .
          </h2>
          <p className="splash-tagline">
            आता अधिक जोमाने, अधिक उत्साहाने उत्तुंग भरारी!
          </p>
        </div>
      )}

      {/* SKIP BUTTON */}
      {started && (
        <button className="splash-skip-btn" onClick={handleSkip}>
          Skip ›
        </button>
      )}

    </div>
  );
};

export default SplashScreen;